export default class MeshEditUndoStack {
    constructor() {
        this._edits = [];
        this._index = -1;
    }

    get canUndo() {
        return this._index >= 0;
    }

    get canRedo() {
        return this._index < this._edits.length - 1;
    }

    edit(deltas) {
        if (this.canRedo) {
            this._edits.splice(this._index + 1);
        }

        this._edits.push(deltas);
        this._index++;
    }

    undo() {
        if (!this.canUndo) {
            return null;
        }

        const deltas = this._edits[this._index];
        this._index--;

        return deltas;
    }

    redo() {
        if (!this.canRedo) {
            return null;
        }

        this._index++;

        return this._edits[this._index];
    }

    clear() {
        this._edits.splice(0);
        this._index = -1;
    }
}
